export const Gender = {
    M: "Macho",
    H: "Hembra"
};